import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { BannerComponent } from './banner/banner.component';
import { CarruselComponent } from './carrusel/carrusel.component';
import { EventEmitterService } from './services/event-emitter.service';
import { AuthService } from './services/auth.service';
import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire';
import { LoginModalComponent } from './login-modal/login-modal.component';
import { RegisterComponent } from './register/register.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserComponent } from './user/user.component';
import { ToursComponent } from './tours/tours.component';
import { SelectorTourComponent } from './selector-tour/selector-tour.component';
import { TourDetailComponent } from './tour-detail/tour-detail.component';
import { AgmCoreModule } from '@agm/core';
import { AddMediaComponent } from './add-media/add-media.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { HttpClientModule } from '@angular/common/http';
import { EmbedVideo } from 'ngx-embed-video';
import { AgmDirectionModule } from 'agm-direction';
import { SelectorUbicacionComponent } from './selector-ubicacion/selector-ubicacion.component';
import { AlertComponent } from './alert/alert.component';

@NgModule({
  declarations: [
    AppComponent,
    NavBarComponent,
    BannerComponent,
    CarruselComponent,
    LoginModalComponent,
    RegisterComponent,
    WelcomeComponent,
    UserComponent,
    ToursComponent,
    SelectorTourComponent,
    TourDetailComponent,
    AddMediaComponent,
    SelectorUbicacionComponent,
    AlertComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    FormsModule,
    ReactiveFormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDzrA7RbnZy0sQsel10ho6ndEkgARrIuFc',
      libraries: ['places']
    }),
    AgmDirectionModule,
    CKEditorModule,
    HttpClientModule, 
    EmbedVideo.forRoot()
  ],
  providers: [AuthService, EventEmitterService],
  bootstrap: [AppComponent]
})
export class AppModule { }
